import { api } from "./api";
import type { Entity, PageResult } from "../types";

/** A API pagina em no máximo 100 itens: busca todas as páginas para não omitir registros em frotas grandes. */
export async function fetchAllPages(name: string, filter = ""): Promise<PageResult<Entity>> {
  const first = await api<PageResult<Entity>>(`/${name}?pageSize=100&page=1${filter}`);
  const items = [...first.items];
  for (let page = 2; items.length < first.total && page <= 50; page += 1) {
    const next = await api<PageResult<Entity>>(`/${name}?pageSize=100&page=${page}${filter}`);
    if (!next.items.length) break;
    items.push(...next.items);
  }
  return { ...first, items };
}
